import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useSiteConfig } from "../context/SiteConfigContext";

const FloatingIcon = () => {
  const { config } = useSiteConfig();

  const formatWhatsappNumber = (number) => {
    if (!number) return "";
    // Remove spaces, dashes, plus signs etc.
    let cleaned = number.toString().replace(/[^0-9]/g, "");
    // Agar already 91 se start nahi ho raha aur 10 digit ka number hai, to 91 add karo
    if (cleaned.length === 10) {
      cleaned = `91${cleaned}`;
    }
    return cleaned;
  };

  const whatsappNumber = formatWhatsappNumber(config?.whatsappNumber);

  return (
    <a
      href={`https://wa.me/${whatsappNumber}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={36} />
    </a>
  );
};

export default FloatingIcon;